/* eslint-disable boundaries/element-types */
import { Steps } from 'antd'
import { AsScanStatusType, getStatusColor } from 'features/fde'
import React from 'react'

interface AsSyncStatusStepsProps {
  scanLevelStatus: Record<string, { status: AsScanStatusType; message: string }>
}

const STATUS_ORDER_MAP: { key: string; title: string }[] = [
  { key: 'upload', title: 'Uploaded to GDrive' },
  { key: 'sync', title: 'Synced to Rolodex' },
  { key: 'auto_measure', title: 'Auto-Measured' },
]

const AsSyncStatusSteps: React.FC<AsSyncStatusStepsProps> = ({
  scanLevelStatus,
}) => {
  const currentStep = STATUS_ORDER_MAP.findIndex((item) => {
    return scanLevelStatus[item.key]['status'] === 'process'
  })

  const stepItems = STATUS_ORDER_MAP.map((item) => ({
    title: (
      <span
        style={{
          color: getStatusColor(
            scanLevelStatus[item.key]['status'] as AsScanStatusType
          ),
        }}>
        {item.title}
      </span>
    ),
    description: <span>Status: {scanLevelStatus[item.key]['message']}</span>,
    status: scanLevelStatus[item.key]['status'] as AsScanStatusType,
  }))

  return (
    <Steps
      className='custom-steps'
      direction='vertical'
      current={currentStep}
      items={stepItems}
    />
  )
}

export default AsSyncStatusSteps
